import { OligoDef, OligoParamDefs } from './param-def';

export type Pricing = {
  currency: string;
  amount: number;
  available: boolean;
  loading?: boolean;
};

export interface Parameter {
  id: string;
  value?: string;
}

export interface BaseParameters {
  researcherName: Parameter;
  oligoName: Parameter;
  oligoValue: Parameter;
  scale: Parameter;
  purification: Parameter;
  prime5Mod: Parameter;
  prime3Mod: Parameter;
}

export interface BasicParameters extends BaseParameters {
  format: Parameter;
  delivery: Parameter;
}

export interface AdvancedParameters {
  alternate: Parameter[];
  handling: Parameter[];
}

export interface OligoParam extends OligoDef<Parameter> {
  basic: BasicParameters;
  advanced: AdvancedParameters;
}

export type OligoDisplayType = 'summary' | 'details';

export const OligoDisplayTypes: {
  SUMMARY: OligoDisplayType;
  DETAILS: OligoDisplayType;
} = {
  SUMMARY: 'summary',
  DETAILS: 'details',
};

export type OligoConfigDisplayType = 'basic' | 'advanced';

export const OligoConfigDisplayTypes: {
  BASIC: OligoConfigDisplayType;
  ADVANCED: OligoConfigDisplayType;
} = {
  BASIC: 'basic',
  ADVANCED: 'advanced',
};

export interface OligoItem {
  id: string;
  index: number;
  parameter: OligoParam;
  definition: OligoParamDefs;
  displayType: OligoDisplayType;
  configDisplayType: OligoConfigDisplayType;
  pricing?: Pricing;
}

export interface ProjectPreference {
  scale: Parameter;
  purification: Parameter;
  format: Parameter;
  isDefault: boolean;
}

export interface ImportProjectPreference extends ProjectPreference {
  delivery: Parameter;
}

export interface ProjectTemplateData extends BaseParameters {
  specialHandling: Parameter;
}

export type ProjectTemplateColumnDefId = 'oligoValue' | 'oligoName' | 'researcherName' | 'scale' |
  'prime5Mod' | 'prime3Mod' | 'purification' | 'specialHandling';

export const ProjectTemplateColumnDefIds: {
  OLIGO_VALUE: ProjectTemplateColumnDefId;
  OLIGO_NAME: ProjectTemplateColumnDefId;
  RESEARCHER_NAME: ProjectTemplateColumnDefId;
  SCALE: ProjectTemplateColumnDefId;
  PRIME_5_MOD: ProjectTemplateColumnDefId;
  PRIME_3_MOD: ProjectTemplateColumnDefId;
  PURIFICATION: ProjectTemplateColumnDefId;
  SPECIAL_HANDLING: ProjectTemplateColumnDefId;
} = {
  OLIGO_VALUE: 'oligoValue',
  OLIGO_NAME: 'oligoName',
  RESEARCHER_NAME: 'researcherName',
  SCALE: 'scale',
  PRIME_3_MOD: 'prime3Mod',
  PRIME_5_MOD: 'prime5Mod',
  PURIFICATION: 'purification',
  SPECIAL_HANDLING: 'specialHandling',
};

export type ProjectTemplateColumnDef = {
  index: number;
  id: ProjectTemplateColumnDefId;
  name: string;
  standardName: string;
};

export type OligoItemError = {
  id: string;
  message: string;
};

export type FileItem = {
  name: string;
  blob: Blob;
  text?: string;
};

export interface ProjectItem {
  id: string;
  index: number;
  name: string;
  preference: ProjectPreference;
  oligos: OligoItem[];
}

export type CartState = 'processing' | 'success' | 'failed';

export const CartStates: {
  PROCESSING: CartState;
  SUCCESS: CartState;
  FAILED: CartState;
} = {
  PROCESSING: 'processing',
  SUCCESS: 'success',
  FAILED: 'failed',
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/models/project.ts